module.exports = __webpack_public_path__ + "img/744.62912dc2.jpg";